window.initFormInputKeypressListener = initFormInputKeypressListener;
async function initFormInputKeypressListener(script) {
    for (const input of script.parentElement.querySelectorAll('form input')) {
        input.addEventListener('keypress', async (event) => {
            if (event.key === 'Enter') {
                await nextFormStep(event.currentTarget);
            }
        });
    }
}

window.nextFormStep = nextFormStep;
async function nextFormStep(element) {
    const form = element.closest('form');
    const licenseKey = form.querySelector('[data-form-step="1"] input').value;
    const licenseKeyPrefix = licenseKey.slice(0, 4);
    const currentStep = form.dataset.currentFormStep;

    if (currentStep === '1') {
        const licensePrefixToFormFields = {
            '0000': ['activationSystemId', 'licenseName', 'activationFailover'],
            '0010': ['activationSystemId', 'activationToken', 'activationFailover'],
            '0020': ['activationSystemId', 'activationToken', 'activationFailover'],
            '0040': ['activationSystemId'],
            '0050': ['activationSystemId', 'userId'],
            '0060': ['activationSystemId'],
            '0070': ['activationSystemId', 'activationToken'],
            '0071': ['activationSystemId', 'activationToken'],
            '0072': ['activationSystemId', 'activationToken'],
        };
        const validKey = validateLicenseKey(form, licenseKey, licenseKeyPrefix, licensePrefixToFormFields);
        if (!validKey) {
            return;
        }
        prepareStepTwoFields(form, licenseKey, licensePrefixToFormFields[licenseKeyPrefix]);
        form.dataset.currentFormStep = (Number(form.dataset.currentFormStep) + 1).toString();
    } else if (currentStep === '2') {
        const body = prepareAndValidateFormData(form, licenseKey);
        if (body === null) {
            return; // input error display handled in the prepareAndValidateFormData function
        }
        const result = await requestActivation(form, licenseKey, body);
        if (result === null) {
            return; // error display handled in the requestActivation function
        }

        const licensePrefixToFileName = {
            '0000': 'activation.dat',
            '0010': 'activation_v2.dat',
            '0020': 'activation_v2.dat',
            '0040': 'activation.json',
            '0050': 'prtgdesktoplicense.dat',
            '0060': 'activation.json',
            '0070': 'activation.dat',
            '0071': 'activation.dat',
            '0072': 'activation.dat',
        };
        renderActivationResults(result, licensePrefixToFileName[licenseKeyPrefix]);
        form.dataset.currentFormStep = 'result';
    }
}

window.previousFormStep = previousFormStep;
function previousFormStep(element) {
    const form = element.closest('form');
    form.querySelector('.js-license-activation-error').classList.add('invisible');
    form.dataset.currentFormStep = '1';
    form.querySelector('.js-css-form-next-button').textContent = form.dataset.formNextButtonText;
    for (const activeField of form.querySelectorAll('[data-active-form-field]')) {
        if (activeField.type === 'hidden') {
            continue;
        }
        activeField.removeAttribute('data-active-form-field');
    }
}

function validateLicenseKey(form, licenseKey, licenseKeyPrefix, licensePrefixToFormFields) {
    if (!licenseKey) {
        const licenseKeyField = form.querySelector('[name="args[licenseKey]"]');
        showInputError(licenseKeyField);
        return false;
    }

    if (!Object.hasOwn(licensePrefixToFormFields, licenseKeyPrefix)) {
        showError(form, 'Your license cannot be activated manually, please contact our support team.');
        return false;
    }

    return true;
}

function prepareStepTwoFields(form, licenseKey, fieldsToShow) {
    // workaround for prtg trial hidden licenseName
    if (licenseKey.startsWith('000023')) {
        const licenseNameField = form.querySelector('[name="args[licenseName]"]');
        licenseNameField.closest('[data-form-step]').style.display = 'none';
        licenseNameField.value = 'prtgtrial';
    } else {
        const licenseNameField = form.querySelector('[name="args[licenseName]"]');
        licenseNameField.closest('[data-form-step]').style.removeProperty('display');
    }

    for (const fieldName of fieldsToShow) {
        const field = form.querySelector(':not([type="hidden"])[name="args[' + fieldName + ']"]');
        field.dataset.activeFormField = 'true';
    }

    form.querySelector('.js-css-form-next-button').textContent = form.dataset.formSubmitButtonText;
}

function prepareAndValidateFormData(form, licenseKey) {
    const body = {
        licenseKey: licenseKey,
    };
    let formError = false;
    for (const activeField of form.querySelectorAll('input[data-active-form-field]')) {
        let bodyFieldName = activeField.name;
        if (bodyFieldName.startsWith('args[')) {
            bodyFieldName = bodyFieldName.substring(5, activeField.name.length - 1);
        }

        if (activeField.type === 'checkbox') {
            body[bodyFieldName] = activeField.checked;
        } else {
            body[bodyFieldName] = activeField.value;
            if (activeField.value === '' && activeField.required) {
                formError = true;
                showInputError(activeField);
            }
        }
    }
    if (formError) {
        return null;
    }
    return body;
}

async function requestActivation(form, licenseKey, body) {
    form.querySelector('.js-license-activation-loading-overlay').style.removeProperty('display');
    const fetchResponse = await fetch(form.dataset.formTargetUrl, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Route-Id': licenseKey.slice(0, 6),
        },
        body: JSON.stringify(body),
    }).catch(function () {
        showError(form, 'Your license cannot be activated manually, please contact our customer support.');
        return null;
    });
    form.querySelector('.js-license-activation-loading-overlay').style.display = 'none';

    if (!fetchResponse) {
        showError(form, 'Your license cannot be activated manually, please contact our customer support.');
        return null;
    }
    if (fetchResponse.status > 300) {
        const errorResponse = await fetchResponse.json().catch(function () {
            showError(form, 'Your license cannot be activated manually, please contact our customer support.');
            return null;
        });
        const errorMessages = errorResponse.map(obj => obj.message);
        const errorResponseMessages = Array.from(new Set(errorMessages));
        showError(form, errorResponseMessages.join('<br/>'));
        return null;
    }

    return await fetchResponse.json();
}

function renderActivationResults(result, fileName) {
    let activationResult = '';
    if (Object.prototype.hasOwnProperty.call(result, 'activationResult')) {
        activationResult = result.activationResult;
    } else {
        activationResult = JSON.stringify(result, undefined, 2);
    }
    document.querySelector('.js-activation-result').textContent = activationResult;
    const blob = new Blob([activationResult], { type: 'application/dat' });
    const url = URL.createObjectURL(blob);
    document.querySelector('.js-download-activation-result-button').setAttribute('href', url);
    document.querySelector('.js-download-activation-result-button').setAttribute('download', fileName);

    document.querySelector('.js-activation-result').addEventListener('copy', (e) => {
        const selection = window.getSelection().toString();
        const textWithNewlines = selection.replace(/\r?\n/g, '\n');
        e.clipboardData.setData('text/plain', textWithNewlines);
        e.preventDefault();
    });
    document.querySelector('.js-copy-activation-result-button').addEventListener('click', () => {
        navigator.clipboard.writeText(activationResult);

        const range = document.createRange();
        range.selectNode(document.querySelector('.js-activation-result'));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.querySelector('.js-activation-result').focus();
    });

}

function showInputError(input) {
    input.classList.add('border-red!');
    input.closest('[data-form-step]').querySelector('.js-error').style.display = 'block';
    input.oninput = function () {
        input.closest('[data-form-step]').querySelector('.js-error').style.display = 'none';
        input.classList.remove('border-red!');
    };
}

function showError(form, message) {
    const errorContainer = form.querySelector('.js-license-activation-error');
    errorContainer.innerHTML = message;
    errorContainer.classList.remove('invisible');
    form.querySelectorAll('input').forEach((item) => {
        item.addEventListener('focus', hideError);
    });
}

function hideError(event) {
    const form = event.target.closest('form');
    form.querySelector('.js-license-activation-error').classList.add('invisible');
    form.querySelectorAll('input').forEach((item) => {
        item.removeEventListener('focus', hideError);
    });
}
